{
    "ChanneltypesLabel": "Tipo(s) de canal:",
    "ChanneltypesOptionAny": "[Qualquer canal]",
    "ChanneltypesOptionVoice": "Chamadas de voz",
    "ChanneltypesOptionChat": "Bate-papo",
    "ChanneltypesOptionEmail": "E-mails",
    "CalltypedirectionLabel": "Tipo\/Direção de Chamada:",
    "CalltypedirectionOptionAny": "[Qualquer tipo de chamada]",
    "CalltypedirectionOptionUnknownorinitiating": "[Desconhecido ou Iniciando]",
    "CalltypedirectionOptionInbound": "Somente entrada",
    "CalltypedirectionOptionOutbound": "Somente saída",
    "CalltypedirectionOptionExternalAll": "Somente Externo",
    "CalltypedirectionOptionExternalInbound": "Externo (somente entrada)",
    "CalltypedirectionOptionExternalOutbound": "Externo (somente saída)",
    "CalltypedirectionOptionExternalTrktotrk": "Tronco a Tronco Externo",
    "CalltypedirectionOptionInternalAll": "Apenas interno",
    "CalltypedirectionOptionInternalInbound": "Interno (somente entrada)",
    "CalltypedirectionOptionInternalOutbound": "Interno (somente saída)",
    "AnswertypeLabel": "Tipo de resposta:",
    "ClicalleridreceivedAny": "[Any]",
    "ClicalleridreceivedNone": "Sem CLI\/CallerID",
    "ClicalleridreceivedReceived": "Com CLI\/CallerID",
    "AnswertypeOptionAny": "[Qualquer tipo de resposta]",
    "AnswertypeOptionNotans": "Não respondido",
    "AnswertypeOptionAns": "Respondidas",
    "AnswertypeOptionAbandoned": "Abandonado",
    "AnswertypeOptionAdvancedFrom": "Avançado de",
    "AnswertypeOptionAdvancedTo": "Avançado para",
    "AnswertypeOptionOverflowedFrom": "Transbordou",
    "AnswertypeOptionOverflowedTo": "Transbordou",
    "ClicalleridreceivedLabel": "CLI \/ CallerID recebido:",
    "DiddigitsLabel": "Dígitos DDI:",
    "AccountcodesLabel": "Código(s) da conta:",
    "CallidentifierLabel": "Identificador de Chamada (Plataforma de Telefonia):",
    "SubjectfilterLabel": "Filtro de assunto:",
    "TreatconfcallasExternalLabel": "Tratar a teleconferência como externa:",
    "MiscellaneousFiltering_SectionHeader": "Filtragem Diversas",
    "MiscellaneousFiltering_AnyPlaceholder": "[Any]",
    "NAME": "MiscellaneousFiltering"
}